/* BebeLux Black Friday Early Access (assets/bb-bf.js, 23.10.2026, Zeitachse 27.10.2026). Im Layout layout/lp-bf.liquid geladen.
 * Zustaende aus sections/bb-bf-hero.liquid (data-ea-start, data-week-start, data-week-end):
 *   pre  bis zum Early-Access-Start, live bis zum Start der BEBE WEEK, week bis zu ihrem Ende, end danach.
 * Das Inline-Skript im Hero setzt html[data-bbbf-state] vor dem ersten Zeichnen; hier laeuft der Countdown
 * und der Zustand wechselt ohne Neuladen, wenn ein Zeitpunkt erreicht ist (nicht bei ?bbbf_state= in der Vorschau).
 * Anmeldung (sections/bb-bf-signup.liquid): seit 27.10.2026 nachmittags wieder ein einziges Formular mit Pflicht-Checkbox
 * (Nayl: "kein 3-Schritte-Quiz"); die Quiz-Funktionen greifen nur bei data-bbbf-quiz. Alle CTAs springen zu #bf-signup.
 * Anmeldung ueber BbBfHub (assets/bb-bf-hub.js) mit der eigenen Bindung aus snippets/bb-bf-form.liquid. Ist dort noch keine
 * Formular-ID eingetragen (data-bbbf-pending), wird nichts montiert.
 * Eine angenommene Anmeldung schaltet alle Formulare der Seite auf Erfolg: der Hub nimmt je Seite
 * nur eine Anfrage an. Eine 202-Antwort ist keine bestaetigte Einwilligung, das Tracking heisst
 * deshalb "signup", nicht "subscribed". Der Lead fuer Meta entsteht serverseitig im Hub (SB-BF26-MAIL-04). */
(function () {
  'use strict';
  if (window.__bbbfInit) return;
  window.__bbbfInit = true;

  var html = document.documentElement;
  var hero = document.querySelector('[data-bbbf-hero]');
  var times = hero ? {
    ea: Date.parse(hero.dataset.eaStart),
    week: Date.parse(hero.dataset.weekStart),
    end: Date.parse(hero.dataset.weekEnd)
  } : null;
  var forced = html.hasAttribute('data-bbbf-forced');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function stateAt(t) {
    if (!times) return 'pre';
    if (!(t >= times.ea)) return 'pre';
    if (!(t >= times.week)) return 'live';
    if (!(t >= times.end)) return 'week';
    return 'end';
  }
  function state() { return html.getAttribute('data-bbbf-state') || 'pre'; }
  function targetOf(s) { return s === 'pre' ? times.ea : s === 'live' ? times.week : s === 'week' ? times.end : NaN; }

  function eventId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'bbbf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function track(name, data) {
    data = data || {};
    data.state = state();
    if (window.sbxClickId) data.sc = window.sbxClickId;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data);
    } catch (e) {}
    try { if (typeof window.plausible === 'function') window.plausible(name, { props: { placement: data.placement || '', state: data.state } }); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name + '_' + (data.placement || '')); } catch (e) {}
  }

  function initCountdowns() {
    var counters = [].slice.call(document.querySelectorAll('[data-bbbf-countdown]'));
    if (!times || !isFinite(times.ea) || !isFinite(times.week) || !isFinite(times.end)) {
      counters.forEach(function (el) { el.hidden = true; });
      return;
    }
    var timer;
    function tick() {
      var now = Date.now();
      if (!forced) {
        var s = stateAt(now);
        if (s !== state()) {
          html.setAttribute('data-bbbf-state', s);
          document.dispatchEvent(new CustomEvent('bbbf:state', { detail: { state: s } }));
        }
      }
      var target = targetOf(state());
      if (!isFinite(target)) { clearInterval(timer); return; }
      var sec = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60), r = sec % 60;
      counters.forEach(function (el) {
        el.querySelector('[data-u="d"]').textContent = pad(d);
        el.querySelector('[data-u="h"]').textContent = pad(h);
        el.querySelector('[data-u="m"]').textContent = pad(m);
        el.querySelector('[data-u="s"]').textContent = pad(r);
      });
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* Kontaktfelder bestimmt die Bindung ("fields"); validierte Attribution wird separat uebertragen. Bindung in
     snippets/bb-bf-form.liquid. Eine event_id je Seitenaufruf: der Hub nimmt nur eine Anmeldung je Seite an,
     dieselbe ID geht an Shopify.analytics (Browser-Pixel nach Einwilligung) und an den Hub (Lead-CAPI). */
  var pageEventId = eventId();
  function extras() {
    var out = { event_id: pageEventId };
    if (optedOut()) { out.ads_optout = '1'; return out; }
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = new URLSearchParams(); }
    ['utm_source', 'utm_campaign'].forEach(function (k) { var v = q.get(k); if (v) out[k] = v.slice(0, 500); });
    var readAttribution = (function(params){var rules={"sc":"^[0-9A-Za-z]{12}$","utm_content":"^[A-Za-z0-9_.:-]{1,128}$","fbclid":"^[A-Za-z0-9_.-]{1,512}$","fbc":"^fb\\.[0-9]{1,2}\\.[0-9]{10,16}\\.[A-Za-z0-9_.-]{1,512}$","fbp":"^fb\\.[0-9]{1,2}\\.[0-9]{10,16}\\.[0-9]{1,30}$","gclid":"^[A-Za-z0-9_-]{1,512}$","gbraid":"^[A-Za-z0-9_-]{1,512}$","wbraid":"^[A-Za-z0-9_-]{1,512}$","ttclid":"^[A-Za-z0-9_.-]{1,512}$"},values={};Object.keys(rules).forEach(function(name){var all=params.getAll(name);if(all.length===1&&!/[\r\n]/.test(all[0])&&new RegExp(rules[name]).test(all[0]))values[name]=all[0];});if(values.fbclid&&values.fbc&&values.fbc.replace(/^fb\.[0-9]{1,2}\.[0-9]{10,16}\./,'')!==values.fbclid)delete values.fbc;return values;});
    var values = readAttribution(q), cookieParams = new URLSearchParams();
    var rawCookies = '';
    try { rawCookies = document.cookie || ''; } catch (e) {}
    rawCookies.split(';').forEach(function (part) {
      var at = part.indexOf('='), name = part.slice(0, at).trim();
      if (at < 0 || (name !== '_fbc' && name !== '_fbp')) return;
      var value = part.slice(at + 1);
      try { value = decodeURIComponent(value); } catch (e) { return; }
      cookieParams.append(name.slice(1), value);
    });
    var cookies = readAttribution(cookieParams);
    var sc = window.sbxClickId;
    if (typeof sc === 'string' && /^[0-9A-Za-z]{12}$/.test(sc)) values.sc = sc;
    // Current URL attribution wins over an older cookie; the server derives a matching fbc.
    var merged = Object.assign({}, cookies, values), params = new URLSearchParams();
    Object.keys(merged).forEach(function (name) { params.set(name, merged[name]); });
    return Object.assign(out, readAttribution(params));
  }

  /* Widerspruch gegen die Meta-Meldung der Anmeldung: Cookie bb_meta_optout=1 auf bebe-lux.de, 2 Jahre.
     Der Wert wird beim Absenden gelesen (extras), ein spaeterer Wechsel nach dem Absenden aendert nichts mehr. */
  var OPTOUT = 'bb_meta_optout';
  function optedOut() { return /(?:^|;\s*)bb_meta_optout=1(?:;|$)/.test(document.cookie); }
  function setOptout(on) {
    var tail = '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    document.cookie = on ? OPTOUT + '=1; max-age=' + (2 * 365 * 24 * 3600) + tail : OPTOUT + '=; max-age=0' + tail;
  }
  /* Normalzustand: freigegebener Satz (data-bbbf-optout-off). Nach dem Widerspruch nur
     "Du hast der Messung mit Meta widersprochen. [Widerspruch zuruecknehmen]" (role=status). */
  function renderOptout(focus) {
    var on = optedOut();
    document.querySelectorAll('[data-bbbf-optout]').forEach(function (box) {
      box.querySelector('[data-bbbf-optout-off]').hidden = on;
      box.querySelector('[data-bbbf-optout-on]').hidden = !on;
    });
    if (focus) {
      var btn = focus.querySelector((on ? '[data-bbbf-optout-on]' : '[data-bbbf-optout-off]') + ' [data-bbbf-optout-toggle]');
      if (btn) btn.focus({ preventScroll: true });
    }
  }
  function initOptout() {
    renderOptout(null);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-bbbf-optout-toggle]');
      if (!btn) return;
      e.preventDefault();
      var on = !optedOut();
      setOptout(on);
      renderOptout(btn.closest('[data-bbbf-optout]'));
    });
  }

  /* Pflichtfelder neben der E-Mail (Nayl 27.10.2026). Die E-Mail prueft der Hub-Transport selbst. */
  function fieldsOf(root) {
    var out = {};
    root.querySelectorAll('[data-bbbf-field]').forEach(function (el) { out[el.getAttribute('data-bbbf-field')] = el.value.trim(); });
    return out;
  }
  /* Telefon als E.164 an den Hub (bf26-mail 27.10.2026), Deutschland als Standard: 0171... -> +49171..., 0049... -> +49... */
  function toE164(raw) {
    var v = String(raw).trim().replace(/[^0-9+]/g, '');
    if (v.indexOf('00') === 0) v = '+' + v.slice(2);
    else if (v.charAt(0) === '0') v = '+49' + v.slice(1);
    else if (v.charAt(0) !== '+') v = '+49' + v;
    return '+' + v.slice(1).replace(/\+/g, '').slice(0, 15);
  }
  function validateStep(root, step) {
    var f = fieldsOf(root);
    if (step >= 1 && (!f.first_name || !f.last_name)) return { step: 1, msg: 'Bitte gib deinen Vor- und Nachnamen ein.' };
    if (step >= 2) {
      var digits = (f.phone || '').replace(/[^0-9]/g, '');
      if (!/^\+?[0-9 ()\/.-]+$/.test(f.phone || '') || digits.length < 7 || digits.length > 15) return { step: 2, msg: 'Bitte gib eine gültige Handynummer ein.' };
    }
    return null;
  }
  function validate(root) {
    var r = validateStep(root, 3);
    if (r) { if (root.hasAttribute('data-bbbf-quiz')) showStep(root, r.step); return r.msg; }
    var box = root.querySelector('[data-bbbf-consent-box]');
    if (box && !box.checked) { box.focus(); return 'Bitte bestätige die Einwilligung, damit wir dir deinen Code schicken dürfen.'; }
    return null;
  }

  /* Einwilligungs-Checkbox (Nayl 27.10.2026): Klick auf den Text schaltet um, Klick auf Datenschutz/Impressum nicht. */
  function initConsent(root) {
    var box = root.querySelector('[data-bbbf-consent-box]');
    var text = root.querySelector('[data-bbbf-consent-text]');
    if (!box || !text) return;
    text.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      box.checked = !box.checked;
      box.dispatchEvent(new Event('change', { bubbles: true }));
    });
    box.addEventListener('change', function () { if (box.checked) showError(root, ''); });
  }

  /* Quiz-Schritte */
  function showError(root, msg) {
    var err = root.querySelector('[data-sf-hub-error]');
    if (!err) return;
    err.textContent = msg || ''; err.hidden = !msg; err.classList.toggle('is-visible', !!msg);
  }
  function currentStep(root) {
    var cur = root.querySelector('[data-bbbf-step]:not([hidden])');
    return cur ? Number(cur.getAttribute('data-bbbf-step')) : 1;
  }
  function showStep(root, n, focus) {
    root.querySelectorAll('[data-bbbf-step]').forEach(function (fs) { fs.hidden = Number(fs.getAttribute('data-bbbf-step')) !== n; });
    var no = root.querySelector('[data-bbbf-step-no]'); if (no) no.textContent = String(n);
    var fill = root.querySelector('[data-bbbf-fill]'); if (fill) fill.style.width = (n / 3 * 100).toFixed(1) + '%';
    if (focus !== false) {
      var first = root.querySelector('[data-bbbf-step="' + n + '"] input:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
  }
  function nextStep(root) {
    var n = currentStep(root);
    var r = validateStep(root, n);
    if (r) { showError(root, r.msg); return; }
    showError(root, '');
    showStep(root, Math.min(3, n + 1));
  }
  function initQuiz(root) {
    var form = root.querySelector('form');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bbbf-next]')) { e.preventDefault(); nextStep(root); }
      else if (e.target.closest('[data-bbbf-back]')) { e.preventDefault(); showError(root, ''); showStep(root, Math.max(1, currentStep(root) - 1)); }
    });
    /* Enter in Schritt 1 und 2 fuehrt weiter statt abzusenden; vor dem Hub-Listener registriert. */
    form.addEventListener('submit', function (e) {
      if (currentStep(root) < 3) { e.preventDefault(); e.stopImmediatePropagation(); nextStep(root); }
    });
    showStep(root, 1, false);
  }

  function mountSignups() {
    var roots = [].slice.call(document.querySelectorAll('[data-bbbf-signup]'));
    var hub = window.BbBfHub;
    if (!roots.length) return true;
    if (roots.every(function (r) { return r.hasAttribute('data-bbbf-pending'); })) return true;
    if (!hub) return false;
    roots.forEach(function (root) {
      if (root.hasAttribute('data-bbbf-pending')) return;
      var form = root.querySelector('form');
      if (root.hasAttribute('data-bbbf-quiz')) initQuiz(root);
      initConsent(root);
      form.addEventListener('input', function () {
        var err = root.querySelector('[data-sf-hub-error]');
        if (err && !err.hidden && !form.querySelector('[disabled]')) { err.textContent = ''; err.hidden = true; err.classList.remove('is-visible'); }
      });
      hub.mount(form, {
        errorElement: root.querySelector('[data-sf-hub-error]'),
        extras: function () {
          var out = extras();
          var f = fieldsOf(root);
          if (f.first_name) out.first_name = f.first_name.slice(0, 80);
          if (f.last_name) out.last_name = f.last_name.slice(0, 80);
          if (f.phone) out.phone = toE164(f.phone);
          return out;
        },
        validate: function () { return validate(root); },
        onBusy: function (busy) { root.classList.toggle('is-busy', busy); },
        onAccepted: function () {
          roots.forEach(function (r) {
            r.classList.add('is-done');
            var ok = r.querySelector('[data-bbbf-success]');
            if (ok) ok.hidden = false;
          });
          var own = root.querySelector('[data-bbbf-success]');
          if (own) own.focus({ preventScroll: true });
          track('bb_bf_early_access_signup', { placement: root.dataset.placement || 'unknown', event_id: pageEventId });
          var bar = document.querySelector('[data-bbbf-sticky]');
          if (bar && state() !== 'week') bar.remove();
        }
      });
    });
    return true;
  }

  function initSignups() {
    if (mountSignups()) return;
    document.addEventListener('sf:bf-hub-ready', function once() {
      document.removeEventListener('sf:bf-hub-ready', once);
      mountSignups();
    });
  }

  function jumpToForm(event) {
    var target = document.querySelector('[data-bbbf-signup-section]') || document.querySelector('[data-bbbf-signup]');
    if (!target) return;
    if (event) { event.preventDefault(); event.stopPropagation(); }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = target.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    var input = target.querySelector('[data-bbbf-step]:not([hidden]) input:not([disabled])') || target.querySelector('[data-bbbf-field="first_name"]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
  }

  /* Mobile Leiste: sichtbar, sobald der Button im Hero nach oben aus dem Bild ist. Ausgeblendet, solange irgendein Teil
     der Anmelde-Section (#bf-signup), ein anderer Angebots-Button oder der Preis-Fuss im Bild ist, und solange ein Feld
     der Seite den Fokus hat (offene Tastatur). Orchestrator-Befund 27.10.2026: die Leiste lag ueber dem Einwilligungstext. */
  function initSticky() {
    var bar = document.querySelector('[data-bbbf-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = null, passed = false, visible = new Set(), focused = false;
    function update() { bar.classList.toggle('is-on', passed && visible.size === 0 && !focused); }
    function watch() {
      if (io) io.disconnect();
      visible = new Set(); passed = false;
      var anchor = document.querySelector('[data-bbbf-hero] .bbbf-offer:not([hidden])');
      var targets = [].slice.call(document.querySelectorAll('[data-bbbf-signup-section], .bbbf-offer, .bbbf-prices__foot'))
        .filter(function (el) { return el.getClientRects().length > 0; });
      if (!targets.length) { bar.classList.remove('is-on'); return; }
      if (!anchor || !anchor.getClientRects().length) anchor = targets[0];
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
          if (en.target === anchor) passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        update();
      }, { threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });
    }
    function isField(el) { return el && el.matches && el.matches('input, textarea, select'); }
    document.addEventListener('focusin', function (e) { if (isField(e.target)) { focused = true; update(); } });
    document.addEventListener('focusout', function () {
      setTimeout(function () { focused = isField(document.activeElement); update(); }, 0);
    });
    watch();
    document.addEventListener('bbbf:state', watch);
  }

  /* Zustand end (ab 01.12.2026): die FAQ-Section ist per CSS ausgeblendet; ihr FAQPage-Markup soll dann auch nicht
     mehr im Dokument stehen (Orchestrator 28.10.2026). Die Seite ist ohnehin noindex (layout/lp-bf.liquid). */
  function initFaqMarkup() {
    function strip() {
      if (state() !== 'end') return;
      [].slice.call(document.querySelectorAll('[id$="__bf_faq"] script[type="application/ld+json"]')).forEach(function (s) {
        if (/FAQPage/.test(s.textContent)) s.parentNode.removeChild(s);
      });
    }
    strip();
    document.addEventListener('bbbf:state', strip);
  }

  function init() {
    initCountdowns();
    initFaqMarkup();
    initOptout();
    initSignups();
    initSticky();
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('[data-bbbf-jump], a[href="#bf-signup"], a[href="#bf-anmeldung"]');
      if (link) { jumpToForm(e); return; }
      var offer = e.target.closest('[data-bbbf-offer]');
      if (offer) track('bb_bf_offer_click', { placement: offer.getAttribute('data-bbbf-offer') });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
